import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

import { apolloClient } from 'lib/withApollo'
import POSTS_QUERY from 'graphql/posts.query'
import { NEWS_POSTS_PER_PAGE } from '@constants'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'

import Layout from 'components/Layout'
import Loading from 'components/Loading'
import WordpressSEO from 'components/WordpressSEO'
import NewsHeader from 'components/NewsHeader'
import ArticleGrid from 'components/ArticleGrid'
import Pagination from 'components/Pagination'

import s from './archive.module.css'

function Archive({
  globalSettings,
  categorySlug,
  page,
  site,
  posts,
  categoriesMenu,
  offsetPagination,
}) {
  const router = useRouter()
  if (router.fallback || !page) return <Loading />

  return (
    <Layout globalSettings={globalSettings}>
      <WordpressSEO
        url={`/${site}/news/archive/${page}`}
        title="Archive"
        desc="Latest news from our talent and models at Select Model London. Select Model Management is an iconic global network of boutique model and talent agencies."
        image={posts?.nodes?.[0]?.acfPost?.featuredImage?.mediaItemUrl}
      />
      <NewsHeader categorySlug={categorySlug} categories={categoriesMenu} />
      {posts?.length > 0 && (
        <ArticleGrid
          className={s.posts}
          articleClassName={s.post}
          articles={posts}
        />
      )}
      <Pagination
        pagination={offsetPagination}
        currentPage={parseInt(page, 10)}
      />
    </Layout>
  )
}

Archive.propTypes = {
  globalSettings: PropTypes.object,
  posts: PropTypes.array,
  categorySlug: PropTypes.string,
  offsetPagination: PropTypes.object,
}
Archive.defaultProps = {
  globalSettings: {},
  posts: null,
  categorySlug: '',
  offsetPagination: {},
}

export default Archive

export async function getStaticProps({ params }) {
  const { site, page } = params

  const { data, error } = await apolloClient().query({
    query: POSTS_QUERY,
    context: { site },
    variables: {
      withCategoriesMenu: true,
      offset: page ? (parseInt(page, 10) - 1) * NEWS_POSTS_PER_PAGE : null,
    },
  })

  if (error) console.log(`Error loading News Archive props - ${error}`)

  return {
    props: {
      ...params,
      categorySlug: null,
      posts: data.posts.nodes,
      categoriesMenu: data.pageBy.acfNews.categoriesMenu,
      offsetPagination: data.posts.pageInfo.offsetPagination,
    },
    revalidate: 60 * 2,
  }
}

export async function getStaticPaths() {
  const paths = []

  // const sites = await getSitesForStaticPaths(
  //   ({ site }) => ({
  //     query: POSTS_QUERY,
  //     context: { site },
  //     variables: {
  //       featuredInBlocks: false,
  //       limit: 1,
  //     },
  //   }),
  //   data =>
  //     Math.ceil(
  //       data.posts.pageInfo.offsetPagination.total / NEWS_POSTS_PER_PAGE
  //     )
  // )

  // sites.forEach(site => {
  //   for (let i = 0; i < site[1] - 1; i++) {
  //     paths.push({
  //       params: {
  //         site: site[0],
  //         page: (i + 2).toString(),
  //       },
  //     })
  //   }
  // })

  return {
    paths,
    fallback: true,
  }
}
